/* eslint-disable @typescript-eslint/naming-convention */
import {
  DAttribute,
  DocumentTypesFormArray,
  IrisMapping,
  SDocumentTypePayload,
  SubmissionAttributeType,
  SubmissionDialogFormData,
} from '../types';
import { FormArray } from '@angular/forms';
import { signal } from '@angular/core';

export function mapDAttributeToSAttribute(
  dAttributes: DAttribute[],
): SubmissionAttributeType[] {
  const sAttributes: SubmissionAttributeType[] = [];
  if (!dAttributes.length) {
    return [];
  }
  for (const attribute of dAttributes) {
    sAttributes.push({
      attribute_type_id: attribute?.id ?? '',
      attribute_type_name: attribute?.name ?? '',
    });
  }
  return sAttributes;
}

export function mapIrisSettings(data: SubmissionDialogFormData): IrisMapping {
  return {
    envelope_type: {
      name: data.irisSettings.envelopeType,
    },
    routing_group: {
      id: +data.irisSettings.routingGroup!.id!,
      name: data.irisSettings.routingGroup?.label ?? '',
    },
  };
}

export function mapDocumentTypeFormToPayload(
  form: DocumentTypesFormArray, 
  action: 'create' | 'update' | 'remove'): SDocumentTypePayload 
{
  return {
    action,
    attribute_type_id: form.controls.attribute?.value?.id ?? '',
    document_type_id: form.controls.documentType?.value?.id ?? '',
  };
}

export function fetchCreatedDocuments(
  documentTypes: FormArray<DocumentTypesFormArray>,
  indexRange: number,
) {
  const payload = signal<SDocumentTypePayload[]>([]);
  if (!documentTypes.length && indexRange <= 0) {
    return payload;
  }

  for (let i = 0; i < indexRange; i++) {
    const cDocument = documentTypes.at(i).value;
    payload.update((arr) => [
      ...arr,
      {
        action: 'create',
        attribute_type_id: cDocument?.attribute?.id,
        document_type_id: cDocument?.documentType?.id,
      },
    ]);
  }
  return payload;
}

export function filterUpdateListDocuments(
  createList: SDocumentTypePayload[],
  updateList: SDocumentTypePayload[],
) {
  return updateList.filter((uList) =>
    createList.every(
      (list) => list.document_type_id !== uList.document_type_id,
    ),
  );
}
